(function() {
	const delegate = new domDelegate.Delegate(document.body);

	// Track clicks on interactive elements
	const selector = [
		'[data-action]',
		'[aria-haspopup]',
		'nav a',
		'.SectionHeader__Links a',
		'.Slideshow__Slide',
		'.PromotedCollections a',
		'.AnnouncementBar__Content a',
		'#primeai_button',
		'#primeai_button2',
		'.primeai_link',
		'#buttoncontid', // primeai
		'[data-section-type=recently-viewed-products]',
		'.ProductRecommendations',
		'.CartUpsell [data-product-handle]',
		'shopify-accelerated-checkout',
		'[data-testid]', // Klaviyo popups
		'.LoyaltyPoints', // header/sidebar loyalty points balance
	].join(', ');
	delegate.on('click', selector, function(event) {
		var target = event.target;
		if (!target.matches(selector)) {
			target = target.closest(selector);
		}
		
		var action, label = null;

		if (target.dataset.action) {
			action = target.dataset.action;
			switch (action) {
				case 'add-to-cart':
					return;
				case 'toggle-collapsible':
				case 'toggle-tab':
					label = target.textContent;
					break;
				case 'select-value':
					label = target.dataset.value;
					var popover = target.closest('.Popover');
					if (popover) label = `${popover.id}: ${label}`;
					break;
				case 'open-drawer':
				case 'close-drawer':
					label = target.dataset.drawerId;
					break;
				case 'open-modal':
				case 'close-modal':
					label = target.getAttribute('aria-controls');
					break;
				case 'add-to-cart-noform':
					label = target.closest('[data-product-handle]')?.dataset.productHandle;
					break;
			}
		} else if (target.ariaHasPopup) {
			action = target.ariaExpanded ? 'open-popover' : 'close-popover';
			label = target.getAttribute('aria-controls');
		} else if (target.matches('nav a')) {
			action = target.closest('.Header__ScrollableNav') ? 'nav-scrollable' : 'nav';
			label = target.childNodes[0].textContent;
			var parent = target.closest('.Collapsible__Inner');
			if (parent) {
				parent = parent.previousElementSibling;
				if (parent.matches('button')) {
					label = `${parent.childNodes[0].textContent} > ${label}`;
				}
			} else {
				var parent = target.closest('.MegaMenu');
				if (parent) {
					parent = parent.previousElementSibling;
					if (parent.matches('a')) {
						label = `${parent.childNodes[0].textContent} > ${label}`;
					}
				}
			}
		} else if (target.matches('.SectionHeader__Links a')) {
			action = 'collection-link';
			label = target.innerText;
		} else if (target.matches('.Slideshow__Slide')) {
			action = target.closest('[data-ga-category]').dataset.gaCategory || 'Slideshow';
			label = `${target.dataset.gaLabel || 'Slide'} (${[...target.parentNode.children].indexOf(target) + 1})`;
		} else if (target.matches('.PromotedCollections a')) {
			action = 'promoted-collection';
			label = target.closest('.PromotedCollections')?.querySelector('.SectionHeader__Heading')?.innerText || target.closest('.PromotedCollections')?.querySelector('.SectionHeader a')?.href.split('/').pop();
		} else if (target.matches('.AnnouncementBar__Content a')) {
			action = 'announcement';
			if (target.closest('#section-announcement-bottom')) {
				action += '-bottom';
			} else if (target.closest('#sidebar-menu')) {
				action += '-mobile-nav';
			} else {
				action += '-top';
			}
			label = target?.innerText;
		} else if (target.matches('#primeai_button') || target.matches('#primeai_button2') || target.matches('#buttoncontid') || target.matches('.primeai_link')) {
			action = 'primeai-size-guide';
			if (target.matches('#buttoncontid')) {
				label = target.querySelector('a, button')?.getAttribute('aria-label');
			} else {
				label = 'open';
			}
		} else if (target.matches('[data-section-type=recently-viewed-products]')) {
			action = 'recently-viewed';
		} else if (target.matches('.ProductRecommendations')) {
			action = 'product-recommendations';
		} else if (target.matches('.CartUpsell [data-product-handle]')) {
			action = 'cart-upsell';
			label = target.dataset.productHandle
		} else if (target.matches('shopify-accelerated-checkout')) {
			action = 'accelerated-checkout';
		} else if (target.dataset.testid) {
			switch (target.dataset.testid) {
				case 'animated-teaser':
					action = 'klaviyo-teaser';
					break;
				default:
					return;
			}
		} else if (target.matches('.LoyaltyPoints')) {
			action = 'loyalty-drawer';
		} else {
			return;
		}

		if (typeof gtag === 'function') gtag('event', 'click', { event_category: action, event_label: label });
	});

	const sendProductListEvent = (items, eventName = 'view_item_list') => {
		try {
			if (!items) return;
			const list = items[0]?.closest('.ProductList');
			if (!list?.dataset?.collectionHandle || typeof gtag !== 'function') return;
			items = Array.from(items).map(item => item.querySelector('.ProductItem'));
			gtag('event', eventName, {
				item_list_id: list.dataset.collectionId,
				item_list_name: list.dataset.collectionTitle,
				items: items.map((item, index) => {
					return {
						index,
						item_id: `shopify_${document.documentElement.dataset.gaId}_${item.dataset.productId}_${item.dataset.variantId}`,
					};
				}),
			});
		} catch(error) {
			console.log(error);
		}
	}
	$(document).on('product_list_loaded', (event, children) => sendProductListEvent(children));
	delegate.on('click', '.ProductItem a', event => sendProductListEvent([event.target.closest('.ProductItem').parentElement], 'select_item'));

	document.querySelectorAll('.ProductRecommendations').forEach(container => {
		const observer = new MutationObserver(() => {
			const list = container.querySelector('.ProductList[data-collection-handle]');

			if (!list) return;

			observer.disconnect();
			$(document).trigger('product_list_loaded', [list.querySelectorAll('.Carousel__Cell')]);
		});

		observer.observe(container, { childList: true });
	});

	window.addEventListener("klaviyoForms", event => {
		const data = { 
			form: 'Klaviyo form',
			form_id: event.detail.formId,
			form_version_id: event.detail.formVersionId,
		};
		let type;

		switch (event.detail.type) {
			case 'open':
			case 'embedOpen':
				type = 'form_open';
				break;
			case 'submit':
				type = 'form_submit';
				break;
			case 'stepSubmit':
				type = 'form_step_submit';
				data.step_name = event.detail.metaData.$step_name;
				break;
			case 'redirectedToUrl':
				type = 'form_url_redirect';
				break;
			case 'close':
				type = 'form_close';
				break;
		}

		if (typeof gtag === 'function') gtag('event', type, data);
	});

	var abval = parseInt(Cookies.get('abval')) % 10;
	if (isNaN(abval)) abval = parseInt(Math.random() * 10);
	document.documentElement.dataset.abval = abval;
	Cookies.set('abval', document.documentElement.dataset.abval, { secure: true, sameSite: 'none' });
	document.addEventListener('trackingLoaded', e => { if (typeof gtag === 'function') gtag('event', 'abval_'+abval) });
})();